function IconSharing(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={21} height={17} xmlns="http://www.w3.org/2000/svg" {...props}>
      <g stroke="currentColor" fill="none" fillRule="evenodd" strokeLinecap="round">
        <path d="M20.026 7.903v8H1v-8M13.5 3.5l-3-3M7.5 3.5l3-3M10.5 11.5V.5" />
      </g>
    </svg>
  );
}

export default IconSharing;
